// extracted by mini-css-extract-plugin
export default {"not-found":"NotFound_not-found__ll4y5","not-found--image":"NotFound_not-found--image__gR6g7","not-found--text":"NotFound_not-found--text__1fEY6"};